// Bilingual dictionary — Telugu (primary) + English
export const translations = {
  te: {
    site_name: "దేవాలయ బంధం",
    nav_home: "హోమ్", nav_temples: "దేవాలయాలు", nav_archakas: "అర్చకులు",
    nav_post: "ప్రకటన ఇవ్వండి", nav_about: "మా గురించి", nav_contact: "సంప్రదించండి",
    login: "లాగిన్", signup: "ఖాతా సృష్టించండి", logout: "లాగ్ అవుట్",
    dashboard: "నా డాష్‌బోర్డ్", admin_panel: "అడ్మిన్ ప్యానెల్",
    lang_toggle: "English", search: "వెతకండి",
    hero_title: "పవిత్ర దేవాలయాలను భక్తిపరులైన అర్చకులతో కలిపే వేదిక",
    hero_sub: "గోత్రం, శాఖ, ఆగమ వివరాలతో సరైన అర్చకులను, దేవాలయాలను కనుగొనండి",
    view_temples: "దేవాలయ ఖాళీలు చూడండి", view_archakas: "అర్చకులను చూడండి",
    post_vacancy: "ఖాళీని పోస్ట్ చేయండి",
    temples_heading: "దేవాలయ ఖాళీలు", archakas_heading: "ఆమోదిత అర్చకులు",
    all_districts: "అన్ని జిల్లాలు", all_gotrams: "అన్ని గోత్రాలు", all_prefs: "అన్ని ప్రాధాన్యతలు",
    filter_gotram: "గోత్రం ద్వారా వడపోత", filter_pref: "ప్రాధాన్యత", filter_purohitam: "గ్రామ పురోహితం",
    salary: "వేతనం", per_month: "నెలకు", deity: "మూలవిరాట్టు", village: "గ్రామం", mandal: "మండలం", district: "జిల్లా",
    ddn: "ధూప దీప నైవేద్యం", free_food: "ఉచిత భోజనం", accommodation: "నివాస వసతి",
    duty_timings: "విధి వేళలు", morning: "ఉదయం", evening: "సాయంత్రం", quarters: "అర్చక క్వార్టర్స్",
    view_details: "వివరాలు చూడండి", unlock_contact: "సంప్రదింపు వివరాలు అన్‌లాక్ చేయండి",
    contact_locked: "సంప్రదింపు వివరాలు లాక్ చేయబడ్డాయి",
    gotram: "గోత్రం", shakha: "శాఖ", sutram: "సూత్రం", agama: "ఆగమం", experience: "అనుభవం", years: "సంవత్సరాలు",
    with_family: "కుటుంబ సమేతంగా సిద్ధం", bachelor: "ఒంటరిగా / బ్యాచిలర్", open_both: "రెండింటికీ సిద్ధం",
    family_preferred: "కుటుంబ సమేత అర్చకులకు ప్రాధాన్యత", bachelor_preferred: "బ్యాచిలర్ అర్చకులకు ప్రాధాన్యత", no_pref: "ప్రాధాన్యత లేదు",
    pref_allowed: "అనుమతి కలదు", pref_not_allowed: "అనుమతి లేదు", pref_after: "దేవాలయ వేళల తర్వాత",
    free_credits: "ఉచిత క్రెడిట్స్", credits_left: "మిగిలి ఉన్నాయి", of: "లో",
    approve: "ఆమోదించండి", reject: "తిరస్కరించండి", pending: "పరిశీలనలో ఉంది",
    approved: "ఆమోదించబడింది", rejected: "తిరస్కరించబడింది",
    notifications: "నోటిఫికేషన్లు", no_notifications: "కొత్త నోటిఫికేషన్లు లేవు", mark_read: "అన్నీ చదివినట్లు గుర్తించండి",
    help_contact: "సహాయం కోసం సంప్రదించండి", call_now: "ఇప్పుడే కాల్ చేయండి", whatsapp: "వాట్సాప్",
    email: "ఇమెయిల్", password: "పాస్‌వర్డ్", full_name: "పూర్తి పేరు", mobile: "మొబైల్ నంబర్",
    role_temple: "దేవాలయం ట్రస్ట్ / కమిటీ సభ్యులు", role_archaka: "అర్చక స్వామి / పురోహితులు",
    select_role: "మీ పాత్రను ఎంచుకోండి", google_signin: "గూగుల్ తో సైన్ ఇన్ చేయండి", or: "లేదా",
    submit: "సమర్పించండి", save: "సేవ్ చేయండి", cancel: "రద్దు చేయండి", loading: "లోడ్ అవుతోంది...",
    pay_now: "చెల్లించండి", proceed_payment: "చెల్లింపునకు కొనసాగండి",
    already_account: "ఇప్పటికే ఖాతా ఉందా?", no_account: "ఖాతా లేదా?",
    otp_sent: "మీ మొబైల్‌కు OTP పంపబడింది", verify_otp: "OTP ధృవీకరించండి", enter_otp: "4-అంకెల OTP నమోదు చేయండి",
    self_upload: "స్వయంగా ఆన్‌లైన్ ఫారం", assisted: "కాల్ / వాట్సాప్ ద్వారా సహాయం",
    ai_assistant: "పూజారి సహాయకుడు", ask_ai: "మీ ప్రశ్న అడగండి...",
    footer_tagline: "పవిత్ర సంప్రదాయాలను గౌరవిస్తూ, దేవాలయాలను అర్చకులతో కలుపుతోంది",
  },
  en: {
    site_name: "Devalaya Bandham",
    nav_home: "Home", nav_temples: "Temple Vacancies", nav_archakas: "Archaka Profiles",
    nav_post: "Post Vacancy", nav_about: "About Us", nav_contact: "Contact Us",
    login: "Login", signup: "Sign Up", logout: "Logout",
    dashboard: "My Dashboard", admin_panel: "Admin Panel",
    lang_toggle: "తెలుగు", search: "Search",
    hero_title: "An auspicious platform connecting sacred temples with devoted archakas",
    hero_sub: "Find the right priests and temples with Gotram, Shakha & Agama details",
    view_temples: "View Temple Vacancies", view_archakas: "Browse Archakas",
    post_vacancy: "Post a Vacancy",
    temples_heading: "Temple Vacancies", archakas_heading: "Approved Archakas",
    all_districts: "All Districts", all_gotrams: "All Gotrams", all_prefs: "All Preferences",
    filter_gotram: "Filter by Gotram", filter_pref: "Preference", filter_purohitam: "Village Purohitam",
    salary: "Remuneration", per_month: "per month", deity: "Deity", village: "Village", mandal: "Mandal", district: "District",
    ddn: "Dhoopa Deepa Naivedyam", free_food: "Free Food", accommodation: "Accommodation",
    duty_timings: "Duty Timings", morning: "Morning", evening: "Evening", quarters: "Archaka Quarters",
    view_details: "View Details", unlock_contact: "Unlock Contact Details",
    contact_locked: "Contact details are locked",
    gotram: "Gotram", shakha: "Shakha", sutram: "Sutram", agama: "Agama", experience: "Experience", years: "years",
    with_family: "Ready with Family", bachelor: "Single / Bachelor", open_both: "Open to Both",
    family_preferred: "Family Priest Preferred", bachelor_preferred: "Bachelor Priest Preferred", no_pref: "No Preference",
    pref_allowed: "Allowed", pref_not_allowed: "Not Allowed", pref_after: "After Temple Hours",
    free_credits: "Free Credits", credits_left: "left", of: "of",
    approve: "Approve", reject: "Reject", pending: "Pending Approval",
    approved: "Approved", rejected: "Rejected",
    notifications: "Notifications", no_notifications: "No new notifications", mark_read: "Mark all as read",
    help_contact: "Contact for Help", call_now: "Call Now", whatsapp: "WhatsApp",
    email: "Email", password: "Password", full_name: "Full Name", mobile: "Mobile Number",
    role_temple: "Temple Trust / Committee Member", role_archaka: "Archaka / Priest",
    select_role: "Select your role", google_signin: "Sign in with Google", or: "or",
    submit: "Submit", save: "Save", cancel: "Cancel", loading: "Loading...",
    pay_now: "Pay Now", proceed_payment: "Proceed to Payment",
    already_account: "Already have an account?", no_account: "No account?",
    otp_sent: "OTP sent to your mobile", verify_otp: "Verify OTP", enter_otp: "Enter 4-digit OTP",
    self_upload: "Self-Upload Online Form", assisted: "Assisted via Call / WhatsApp",
    ai_assistant: "Poojari Assistant", ask_ai: "Ask your question...",
    footer_tagline: "Honouring sacred traditions, connecting temples with archakas",
  },
};

// All districts of Andhra Pradesh (26) + Telangana (33)
export const DISTRICTS = [
  // ఆంధ్రప్రదేశ్
  "అల్లూరి సీతారామరాజు", "అనకాపల్లి", "అనంతపురం", "అన్నమయ్య", "బాపట్ల", "చిత్తూరు",
  "కోనసీమ", "తూర్పు గోదావరి", "ఏలూరు", "గుంటూరు", "కాకినాడ", "కృష్ణా", "కర్నూలు",
  "నంద్యాల", "ఎన్టీఆర్", "పల్నాడు", "పార్వతీపురం మన్యం", "ప్రకాశం", "శ్రీకాకుళం",
  "శ్రీ సత్యసాయి", "శ్రీ పొట్టి శ్రీరాములు నెల్లూరు", "తిరుపతి", "విశాఖపట్నం",
  "విజయనగరం", "పశ్చిమ గోదావరి", "వైఎస్ఆర్ కడప",
  // తెలంగాణ
  "ఆదిలాబాద్", "భద్రాద్రి కొత్తగూడెం", "హనుమకొండ", "హైదరాబాద్", "జగిత్యాల", "జనగాం",
  "జయశంకర్ భూపాలపల్లి", "జోగులాంబ గద్వాల", "కామారెడ్డి", "కరీంనగర్", "ఖమ్మం",
  "కొమురం భీమ్ ఆసిఫాబాద్", "మహబూబాబాద్", "మహబూబ్ నగర్", "మంచిర్యాల", "మేడక్",
  "మేడ్చల్ మల్కాజ్‌గిరి", "ములుగు", "నాగర్ కర్నూల్", "నల్గొండ", "నారాయణపేట",
  "నిర్మల్", "నిజామాబాద్", "పెద్దపల్లి", "రాజన్న సిరిసిల్ల", "రంగారెడ్డి",
  "సంగారెడ్డి", "సిద్ధిపేట", "సూర్యాపేట", "వికారాబాద్", "వనపర్తి", "వరంగల్",
  "యాదాద్రి భువనగిరి",
];

export const GOTRAMS = [
  "భారద్వాజస", "కౌశిక", "కాశ్యప", "వశిష్ట", "ఆత్రేయ", "గౌతమ", "శ్రీవత్స", "హరిత",
  "విశ్వామిత్ర", "జమదగ్ని", "అగస్త్య", "పరాశర", "సాంకృత్య", "మౌద్గల్య",
];

export const SHAKHAS = [
  "యజుర్వేదం (తైత్తిరీయ శాఖ)", "రుగ్వేదం", "సామవేదం", "అథర్వణ వేదం",
];

export const SUTRAMS = [
  "ఆపస్తంబ సూత్రం", "ఆశ్వలాయన సూత్రం", "ద్రాహ్యాయణ సూత్రం", "బోధాయన సూత్రం", "కాత్యాయన సూత్రం",
];
